import { MessageUserRecipientDoc, generateRecordId, MessageGroupRecipientDoc } from "libs/schema";
import { isDefined } from "../predicates";
import { CamelCasedProperties } from "type-fest";
import { pickBy } from "lodash-comms";

/* -------------------------------------------------------------------------------------------------
 *  helpers
 * -------------------------------------------------------------------------------------------------
 */

export type CreateMessageUserRecipientProps = CamelCasedProperties<Omit<MessageUserRecipientDoc, "id" | "type">>;

export function createMessageUserRecipient(props: CreateMessageUserRecipientProps): MessageUserRecipientDoc {
  return pickBy(
    {
      id: generateRecordId("message_user_recipient_doc", {
        type: "USER",
        user_id: props.userId,
      }),
      type: "USER",
      user_id: props.userId,
      priority: props.priority,
      is_implicit: props.isImplicit,
      is_mentioned: props.isMentioned,
      request_complete: props.requestComplete,
      respond_by: props.respondBy,
    } satisfies MessageUserRecipientDoc,
    isDefined,
  ) as MessageUserRecipientDoc;
}

/* -----------------------------------------------------------------------------------------------*/

export type CreateMessageGroupRecipientProps = CamelCasedProperties<Omit<MessageGroupRecipientDoc, "id" | "type">>;

export function createMessageGroupRecipient(props: CreateMessageGroupRecipientProps) {
  return pickBy(
    {
      id: generateRecordId("message_group_recipient_doc", {
        type: "GROUP",
        group_id: props.groupId,
      }),
      type: "GROUP",
      group_id: props.groupId,
      priority: props.priority,
      is_implicit: props.isImplicit,
      is_mentioned: props.isMentioned,
      request_complete: props.requestComplete,
      respond_by: props.respondBy,
    } satisfies MessageGroupRecipientDoc,
    isDefined,
  ) as MessageGroupRecipientDoc;
}

/* -----------------------------------------------------------------------------------------------*/
